// These values are stored at the back end. If someone changes ids of countries in the back end
// then it has to be changed here

export enum Countries {
    GERMANY = 'b5f21638-95f3-4a34-901c-865e7a409655',
    SWITZERLAND = 'd78cb8f3-2c21-4ec8-a2dc-bafbe0045ef9',
    AUSTRIA = 'd9f269a5-ba1c-4abc-ad2a-bf8400e221d1',
}
